(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-target]');
        if (!button) return;
        showMedia(gallery, button.dataset.galleryTarget);
      });
    });
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const select = section.querySelector('[data-variant-select]');
      const quantity = section.querySelector('[data-quantity]');
      if (!select || !quantity) return;
      const currency = section.querySelector('[data-product-currency]').textContent.trim() || 'EUR';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
      const format = cents => money.format(cents / 100);
      function limits() {
        const option = select.selectedOptions[0];
        return { min: Number(option.dataset.min) || 1, step: Number(option.dataset.step) || 1, max: Number(option.dataset.max) || Infinity };
      }
      function updateQuantity() {
        const {min, step, max} = limits();
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        const upper = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
        value = Math.max(min, Math.min(upper, min + Math.floor((value - min) / step) * step));
        quantity.value = String(value);
        section.querySelectorAll('[data-gift-quantity]').forEach(input => { input.checked = Number(input.value) === value; });
      }
      function updateVariant(changeUrl = false) {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const {min, step, max} = limits();
        quantity.min = String(min); quantity.step = String(step);
        if (Number.isFinite(max)) quantity.max = String(max); else quantity.removeAttribute('max');
        section.querySelectorAll('[data-unit-price]').forEach(el => { el.textContent = option.dataset.money; });
        section.querySelectorAll('[data-compare-price]').forEach(el => { el.textContent = option.dataset.compareMoney; el.hidden = !(Number(option.dataset.compare) > Number(option.dataset.price)); });
        section.querySelectorAll('[data-add-button]').forEach(button => { button.disabled = !available; button.querySelector('[data-add-label]').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel; });
        section.querySelectorAll('[data-gift-quantity]').forEach(input => { const n = Number(input.value); input.disabled = n < min || n > max || (n - min) % step !== 0; });
        section.querySelectorAll('[data-gift-total]').forEach(el => { el.textContent = format(Math.round(Number(option.dataset.price) * Number(el.dataset.giftTotal) * (Number(el.dataset.giftTotal) >= 2 ? 0.85 : 0.95))); });
        updateQuantity();
        if (option.dataset.imageId) showMedia(section.querySelector('[data-gallery]'), option.dataset.imageId);
        if (changeUrl && section.dataset.updateUrl === 'true') { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
      }
      select.addEventListener('change', () => updateVariant(true));
      quantity.addEventListener('change', updateQuantity);
      section.addEventListener('click', event => { const control = event.target.closest('[data-quantity-adjust]'); if (!control) return; quantity.value = String(Number(quantity.value) + Number(control.dataset.quantityAdjust) * limits().step); updateQuantity(); });
      section.querySelectorAll('[data-gift-quantity]').forEach(input => input.addEventListener('change', () => { quantity.value = input.value; updateQuantity(); }));
      const form = section.querySelector('.product-form');
      form?.addEventListener('submit', () => updateQuantity());
      const sticky = section.querySelector('[data-sticky-buy]');
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold: 0});
        observer.observe(form);
      }
      updateVariant();
    });
  }
  function showMedia(gallery, id) {
    if (!gallery) return;
    const target = Array.from(gallery.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === String(id));
    if (!target) return;
    gallery.querySelectorAll('[data-media-id]').forEach(el => { el.hidden = el !== target; if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause()); });
    gallery.querySelectorAll('[data-gallery-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(id))));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
})();
